$(document).ready(function () {
    pageOptions.init();
});

// The three dots next to each record list
var pageOptions = {};

pageOptions.bind = function () {
    pageOptions.body.addEventListener('click', function (e) {
        pageOptions.checkClick(e);
    });

    pageOptions.editButton.off('click.editbutton').on('click.editbutton', function (e) {
        pageOptions.deactivate();
        pageOptions.toggleSubNav(e);
    });
};

pageOptions.checkClick = function (e) {

    if (e.target.classList.contains(pageOptions.editButtonClass)) {
        pageOptions.removeBodyListener();
    } else if (e.target.parentNode.classList.contains(pageOptions.editButtonClass)) {

        pageOptions.removeBodyListener();
    } else {

        pageOptions.deactivate();
    }
};

pageOptions.toggleSubNav = function (j) {

    if (j.currentTarget.classList.contains(pageOptions.activeClass)) {
        pageOptions.deactivate();
    } else {

        j.currentTarget.classList.add(pageOptions.activeClass);
    }
};

pageOptions.deactivate = function () {
    for (var i = 0; i < pageOptions.editButton.length; i++) {
        pageOptions.editButton[i].classList.remove(pageOptions.activeClass);
    };

    pageOptions.removeBodyListener();
};

pageOptions.removeBodyListener = function () {
    pageOptions.body.removeEventListener('click', pageOptions.checkClick, false);
};

pageOptions.init = function () {
    pageOptions.editButton = $('.edit-button');
    pageOptions.body = document.getElementsByTagName('body')[0];

    pageOptions.dropdownClass = 'site-header__dropdown';
    pageOptions.activeClass = 'active';
    pageOptions.editButtonClass = 'edit-button';

    if (document.getElementsByClassName(pageOptions.editButtonClass).length > 0) {
        pageOptions.bind();
    }
};